import React, { useState, useEffect } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
import {
  Beds,
  Baths,
  minPriceOptions,
  maxPriceOptions,
} from "../store/Dropdowndata";
// API base path from environment variable, defaults to empty string for relative paths
const API_BASE_PATH = process.env.REACT_APP_RESOAPI_BASE_URL || "";

const SearchFields = ({
  onSearch,
  showMoreOptionsButton = true,
  showSearchButton = true,
  onMoreOptionsClick,
  isMoreOptionsVisible = false,
  initialValues = {},
  compact = false,
  onSearchTextChange, // Callback to notify parent when search text changes
}) => {
  const [autocompletevalue, setautocompleteValue] = useState(initialValues.searchtext || "");
  const [autocompleteInput, setAutocompleteInput] = useState("");
  const [autocompleteitems, setautocompleteItems] = useState([]);
  const [selectedMinprice, setSelectedMinprice] = useState(initialValues.minprice || null);
  const [selectedMaxprice, setSelectedMaxprice] = useState(initialValues.maxprice || null);
  const [selectedBeds, setSelectedBeds] = useState(initialValues.beds || null);
  const [selectedBaths, setSelectedBaths] = useState(initialValues.baths || null);

  // Update local state when initialValues change
  useEffect(() => {
    if (initialValues.searchtext) {
      setautocompleteValue(initialValues.searchtext);
      setAutocompleteInput(
        initialValues.searchtext?.label || initialValues.searchtext || ""
      );
    }
    if (initialValues.minprice) setSelectedMinprice(initialValues.minprice);
    if (initialValues.maxprice) setSelectedMaxprice(initialValues.maxprice);
    if (initialValues.beds) setSelectedBeds(initialValues.beds);
    if (initialValues.baths) setSelectedBaths(initialValues.baths);
  }, [initialValues]);

  const autocompletesearch = async (event) => {
    const query = encodeURIComponent(event.query || "");
    const url = `${API_BASE_PATH}/Api/Search/AutoCompleteSearchText?txt=${query}&buyorrent=0&getLocationType=&notConsidering=&considerCityforCounties=`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        setautocompleteItems([]);
        return;
      }
      const data = await response.json();
      const suggestions = (data || []).map((item) => {
        const arr = item.split("/");
        if (arr[1] === "clear") {
          return { label: arr[0], value: null, header: true };
        }
        return { label: arr[0], value: arr[1] };
      });
      setautocompleteItems(suggestions);
    } catch (err) {
      setautocompleteItems([]);
    }
  };

  const handleSearchSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const formData = {
      searchtext: autocompletevalue,
      minprice: selectedMinprice,
      maxprice: selectedMaxprice,
      beds: selectedBeds,
      baths: selectedBaths,
    };
    if (onSearch) {
      onSearch(formData);
    }
  };

  const getFormData = () => ({
    searchtext: autocompletevalue,
    minprice: selectedMinprice,
    maxprice: selectedMaxprice,
    beds: selectedBeds,
    baths: selectedBaths,
  });

  return (
    <div className={`search-fields-component ${compact ? 'compact' : ''}`}>
      <div className="mb-3">
        <div className="card flex justify-content-center">
          <AutoComplete
            inputId="searchtext"
            className="form-control"
            inputStyle={{ width: "100%", border: "none" }}
            placeholder="Enter City or ZIP"
            value={autocompleteInput}
            suggestions={autocompleteitems}
            completeMethod={autocompletesearch}
            onChange={(e) => {
              setAutocompleteInput(e.value || "");
            }}
            onSelect={(e) => {
              if (e.value && !e.value.header) {
                setautocompleteValue(e.value);
                setAutocompleteInput(e.value.label || e.value);
                // Notify parent component of the change
                if (onSearchTextChange) {
                  onSearchTextChange(e.value);
                }
              }
            }}
            field="label"
            itemTemplate={(item) => {
              if (item.header) {
                return (
                  <div
                    style={{
                      fontWeight: "bold",
                      color: "#888",
                      pointerEvents: "none",
                      background: "#f8f9fa",
                    }}
                  >
                    {item.label}
                  </div>
                );
              }
              return <div>{item.label}</div>;
            }}
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-6">
          <div className="card flex justify-content-center">
            <Dropdown
              id="minprice"
              value={selectedMinprice}
              onChange={(e) => {
                setSelectedMinprice(e.value);
              }}
              options={minPriceOptions}
              optionLabel="name"
              placeholder="Price Min"
              className="w-full md:w-14rem"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card flex justify-content-center">
            <Dropdown
              id="maxprice"
              value={selectedMaxprice}
              onChange={(e) => {
                setSelectedMaxprice(e.value);
              }}
              options={maxPriceOptions}
              optionLabel="name"
              placeholder="Price Max"
              className="w-full md:w-14rem"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card flex justify-content-center">
            <Dropdown
              id="beds"
              value={selectedBeds}
              onChange={(e) => {
                setSelectedBeds(e.value);
              }}
              options={Beds}
              optionLabel="name"
              placeholder="Beds"
              className="w-full md:w-14rem"
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card flex justify-content-start">
            <Dropdown
              id="baths"
              value={selectedBaths}
              onChange={(e) => {
                setSelectedBaths(e.value);
              }}
              options={Baths}
              optionLabel="name"
              placeholder="Baths"
              className="w-full md:w-14rem"
            />
          </div>
        </div>
        {showMoreOptionsButton && (
          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-outline-light w-100"
              id="toggleFilters"
              onClick={onMoreOptionsClick}
            >
              <img
                src={require("../assets/image/banner/Group.png")}
                id="info_s"
                alt="More Options"
              />
              More Options
            </button>
          </div>
        )}
        {showSearchButton && (
          <div className={showMoreOptionsButton ? "col-md-6" : "col-md-12"}>
            <button
              type="submit"
              className="btn btn-teal text-white px-4 w-100"
              onClick={handleSearchSubmit}
            >
              Search Homes
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchFields;
